import { render, staticRenderFns } from "./LinearLabel.vue?vue&type=template&id=39565c73&scoped=true"
import script from "./LinearLabel.vue?vue&type=script&lang=ts"
export * from "./LinearLabel.vue?vue&type=script&lang=ts"
import style0 from "./LinearLabel.vue?vue&type=style&index=0&id=39565c73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39565c73",
  null
  
)

export default component.exports